import { showModal } from 'actions';
import { startProgram } from 'actions/Broadcast';
import { BROADCAST_JOIN_MEETING } from '../Types';
import {
  createConfiguration,
  addDeviceEventObserverToSession,
  realtimeSetCanUnmuteLocalAudio,
  realtimeUnmuteLocalAudio
} from '@studio/chime';
import { CAMERA_PRESENTER } from '@shoflo/polymer';
import { withCurrentParams } from '../utils';
import {
  SOURCE_ROLE_SPEAKER,
  NO_DEVICE_FOUND,
  PERMISSION_DENIED
} from '@studio/constants';
import { SOURCE_CREATE } from '@shoflo/studio-redux/constants/SocketEvents';
import {
  removeSandboxMeetingAttendee,
  getCurrentBroadcast
} from '@shoflo/studio-redux/actions';

/**
 * Join a meeting without knocking
 * @param name
 * @param description
 * @returns {(function(*, *, *): void)|*}
 */
function joinMeetingWithoutKnock(name, description, sessionId, endJoinSLI) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const { readinessCheck, user } = getState();
      const action = {
        type: BROADCAST_JOIN_MEETING,
        request: async apiClient => {
          try {
            const { meetingResponse, attendeeResponse } =
              await apiClient.broadcast.createMeeting(
                teamId,
                eventId,
                broadcastId,
                {
                  sessionId
                }
              );

            const { meetingSession } = createConfiguration(
              meetingResponse,
              attendeeResponse
            );
            const { camera } = readinessCheck || {};
            const presenterSessionId = `Presenter-${user._id}-${sessionId}`;

            const source = await apiClient.broadcast.createSource(
              teamId,
              eventId,
              broadcastId,
              {
                order: 1,
                value: attendeeResponse.Attendee.AttendeeId,
                description,
                type: CAMERA_PRESENTER,
                title: name,
                userId: user._id,
                role: SOURCE_ROLE_SPEAKER,
                cameraUnavailable:
                  camera === NO_DEVICE_FOUND || camera === PERMISSION_DENIED
              }
            );
            const notifyingDirector = attendeeResponse?.Attendee.AttendeeId;
            socket.emit(SOURCE_CREATE, {
              broadcastId,
              notifyingDirector
            });
            addDeviceEventObserverToSession(
              dispatch,
              showModal,
              meetingSession
            );
            await realtimeSetCanUnmuteLocalAudio(meetingSession, true);
            await realtimeUnmuteLocalAudio(meetingSession);
            endJoinSLI(
              [
                {
                  presenterSessionId,
                  ...source
                }
              ],
              undefined
            );
            return {
              meetingResponse,
              attendeeResponse,
              meetingSession
            };
          } catch (e) {
            endJoinSLI(undefined, e);
            throw e;
          }
        }
      };
      dispatch(action);
      dispatch(removeSandboxMeetingAttendee());
      dispatch(startProgram());
      dispatch(getCurrentBroadcast());
    }
  );
}

export default joinMeetingWithoutKnock;
